{
  "enum": {
    "IxmAuthV1ApiKeyStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxmAuthV1ApiKeyQueryServiceApiKeyListFilterableFields": {
      "clientId": "Client ID",
      "status": "Status",
      "tenantId": "Tenant",
      "tenantType": "Tenant Type"
    }
  },
  "oneOf": {
    "IxmAuthV1ApiKeyEventType": {
      "archived": "Archived",
      "created": "Created",
      "keyUsed": "Key Used",
      "updated": "Updated"
    }
  },
  "sortEnum": {
    "IxmAuthV1ApiKeyQueryServiceApiKeyListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}